var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Grow from '@material-ui/core/Grow';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import { useBaseI18n } from '../hooks';
var SearchInput = function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, defaultValue = _a.defaultValue, _c = _a.InputProps, _d = _c === void 0 ? {} : _c, _e = _d.classes, cl = _e === void 0 ? {} : _e, InputProps = __rest(_d, ["classes"]), _f = _a.inputProps, _g = _f === void 0 ? {} : _f, maxLength = _g.maxLength, inputProps = __rest(_g, ["maxLength"]), rest = __rest(_a, ["onChange", "defaultValue", "InputProps", "inputProps"]);
    var _h = useState(defaultValue || ''), searchValue = _h[0], setSearchValue = _h[1];
    var initialMount = useRef(true);
    var classes = useStyles();
    var placeholder = useBaseI18n(function (i18n) { return i18n.searchInput.search; });
    var onValueCange = function (event) {
        setSearchValue(event.target.value);
    };
    var onSearch = useCallback(function () {
        onChange(searchValue || '');
    }, [searchValue, onChange]);
    var onCancel = useCallback(function () {
        setSearchValue('');
    }, [searchValue]);
    useEffect(function () {
        if (initialMount.current) {
            initialMount.current = false;
            return;
        }
        var timer = setTimeout(function () {
            onChange(searchValue);
        }, 400);
        return function () {
            clearTimeout(timer);
        };
    }, [searchValue]);
    return (_jsx(TextField, __assign({ type: "text", autoComplete: "off", variant: "filled", value: searchValue, onChange: onValueCange, placeholder: placeholder, InputProps: __assign({ disableUnderline: true, classes: __assign(__assign({}, cl), { root: clsx(classes.inputRoot, cl.root), input: clsx(classes.input, cl.input) }), startAdornment: (_jsx(IconButton, __assign({ color: "primary", className: classes.iconButton, onClick: onSearch }, { children: _jsx(SearchIcon, { className: classes.icon }, void 0) }), void 0)), endAdornment: (_jsx(Grow, __assign({ "in": !!searchValue, timeout: 100 }, { children: _jsx(IconButton, __assign({ color: "primary", className: classes.iconButton, onClick: onCancel }, { children: _jsx(CloseIcon, { className: classes.icon }, void 0) }), void 0) }), void 0)) }, InputProps), inputProps: __assign(__assign({}, inputProps), { maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : 250 }) }, rest), void 0));
};
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return ({
        inputRoot: (_a = {
                borderRadius: 999,
                padding: '0 2.96px',
                backgroundColor: '#F5F5F5',
                transition: 'background-color 0.5s ease',
                '&:hover, &:focus-within': {
                    backgroundColor: '#ECECEC'
                }
            },
            _a[theme.breakpoints.down(500)] = {
                padding: '0 4px'
            },
            _a[theme.breakpoints.up(1600)] = {
                padding: '0 4px'
            },
            _a),
        input: (_b = {
                padding: 0,
                color: theme.palette.primary.main,
                fontFamily: 'Assistant-Regular',
                fontSize: 17.77
            },
            _b[theme.breakpoints.down(500)] = {
                fontSize: 24
            },
            _b[theme.breakpoints.up(1600)] = {
                fontSize: 24
            },
            _b),
        iconButton: (_c = {
                padding: 8.8
            },
            _c[theme.breakpoints.down(500)] = {
                padding: 12
            },
            _c[theme.breakpoints.up(1600)] = {
                padding: 12
            },
            _c),
        icon: (_d = {
                height: 17.77,
                width: 17.77
            },
            _d[theme.breakpoints.down(500)] = {
                height: 24,
                width: 24
            },
            _d[theme.breakpoints.up(1600)] = {
                height: 24,
                width: 24
            },
            _d)
    });
});
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map